export default __webpack_public_path__ + "static/media/test.1916bd52.mp4";